import { defineStore } from "pinia";
import { ref } from "vue";
import { mountSortablePlugins } from "@/utils/sortablejsPlugins";
import type { DraggingState } from "@/components/table/types";

// Should be called once for the entire app instance
mountSortablePlugins();

export const useDraggingStatusStore = defineStore("draggingStatus", () => {
  const draggingState = ref<DraggingState>();

  function startDragging(state: DraggingState) {
    // When dragging across tables, start and end happen on the SOURCE table
    draggingState.value = {
      ...state,
    };
  }

  function endDragging() {
    draggingState.value = undefined;
  }

  const isDragging = computed(() => draggingState.value !== undefined);
  const isDraggingAcrossTables = computed(() => draggingState.value?.from !== draggingState.value?.to);

  return {
    startDragging,
    endDragging,
    isDragging,
    isDraggingAcrossTables,
    draggingState,
  };
});
